import { BUTTON_SIZE, BUTTON_TYPE, DSButton } from '@repo/design-system/index'
import { QIcon_close_default } from '@repo/icons/index'
import { motion } from 'framer-motion'
import { useEffect, useState } from 'react'
import { useEventTracking } from '../helpers/gtmHelper'
import useIsWebview from '../modules/hooks/common/useIsWebview'
import { n_module } from '../modules/i18n/strings/auto/wording'
import useTranslation from '../modules/i18n/useTranslation'

const Timer = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.16658 1.3335C6.7984 1.3335 6.49992 1.63197 6.49992 2.00016C6.49992 2.36835 6.7984 2.66683 7.16658 2.66683H7.83325V3.3723C5.01797 3.7022 2.83325 6.09563 2.83325 9.00016C2.83325 12.1296 5.37049 14.6668 8.49992 14.6668C11.63 14.6668 14.1666 12.1296 14.1666 9.00016C14.1666 7.07317 13.2052 5.37112 11.7358 4.3474L11.988 3.91069C12.172 3.59183 12.0628 3.1841 11.7439 3.00001C11.4251 2.81591 11.0173 2.92516 10.8333 3.24402L10.559 3.71906C10.1189 3.54741 9.65215 3.42916 9.16658 3.37228V2.66683L9.83325 2.66683C10.2014 2.66683 10.4999 2.36835 10.4999 2.00016C10.4999 1.63197 10.2014 1.3335 9.83325 1.3335H7.16658Z"
        fill="#72B5FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.2614 8.56652L8.26105 8.56683L8.26107 8.56685C8.02482 8.80314 8.02483 9.18621 8.26111 9.42249C8.4974 9.65878 8.88051 9.65878 9.1168 9.42249C9.13085 9.40844 9.14406 9.39387 9.15644 9.37884L11.256 7.06937L11.2559 7.06936C11.256 7.06933 11.256 7.0693 11.256 7.06927C11.4333 6.89205 11.4333 6.60472 11.256 6.42751C11.0788 6.25029 10.7915 6.25029 10.6143 6.42751C10.6142 6.42762 10.6141 6.42772 10.6139 6.42783L8.30405 8.52774C8.28937 8.53987 8.27514 8.55279 8.2614 8.56652Z"
        fill="#D9F0FF"
      />
    </svg>
  )
}
const RecommendTutorPopup = ({ tutor, isVisible, onClose, duration = 5, setShowTutorTime }) => {
  const { t } = useTranslation()
  const [remainingTime, setRemainingTime] = useState(duration)
  const { sendPageViewEvent, sendClickEvent } = useEventTracking()
  const isWebview = useIsWebview()

  useEffect(() => {
    if (!isVisible) return
    setRemainingTime(duration)
    sendPageViewEvent({ page_name: 'book_offer' })

    const interval = setInterval(() => {
      setRemainingTime((prevTime) => {
        const updatedTime = prevTime - 1
        if (updatedTime <= 0) {
          clearInterval(interval)
          onClose()
          return 0
        } else {
          return updatedTime
        }
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [isVisible, onClose, duration])

  const animationVariants = {
    hidden: { opacity: 0, x: 0, y: 100 },
    visible: { opacity: 1, x: 0, y: 0, transition: { type: 'spring', stiffness: 100 } },
  }

  const handleClick = () => {
    sendClickEvent({ button_name: 'view_more', location_detail: 'book_suggestion_modal' })
    setShowTutorTime(true)
  }

  return (
    <motion.div
      initial="hidden"
      animate={isVisible ? 'visible' : 'hidden'}
      variants={animationVariants}
      className="p-[0px] sm:p-[20px] rounded-[8px] fixed w-full sm:w-[400px] text-center bottom-[0px] right-[0px] sm:bottom-[28px] sm:right-[28px] z-[999]"
    >
      <div className="rounded-[16px] bg-white shadow-[0px_2px_8px_0px_rgba(0,0,0,0.15)] px-[8px] py-[4px] inline-flex mx-auto items-center justify-center gap-x-[4px]">
        <div className="text-blue-600 Body2-14Bd rounded-[12px] bg-blue-50 flex items-center gap-x-[2px] px-[6px] py-[2px]">
          <Timer />
          {t(n_module.timer.amount(remainingTime))}
        </div>
        <div className="Body1-16Bd text-gray-600">{t(n_module.timer.cpation)}</div>
      </div>
      <div className="bg-white mt-[16px] relative p-[20px] w-full rounded-[4px] shadow-[0_2px_8px_0_rgba(0,0,0,0.15)]">
        {tutor && (
          <div>
            <img src={tutor.image_url} className="w-[96px] h-[96px] rounded-[20px] mx-auto" />
            <div className="mt-[16px] Title1-20Bd text-center">{t(n_module.one_click.title(tutor.first_name))}</div>
            <div className="mt-[32px]">
              <DSButton type={BUTTON_TYPE.SOLID} size={BUTTON_SIZE.XL} onClick={handleClick}>
                <DSButton.Label>{t(n_module.one_click.btn_1)}</DSButton.Label>
              </DSButton>
            </div>
          </div>
        )}

        <button
          className="absolute right-[20px] top-[20px]"
          onClick={() => {
            sendClickEvent({ button_name: 'close', location_detail: 'book_suggestion_modal' })
            onClose()
          }}
        >
          <QIcon_close_default width={24} height={24} />
        </button>
      </div>
    </motion.div>
  )
}

export default RecommendTutorPopup
